module.exports = __webpack_public_path__ + "static/img/66.5464c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/66.png
// module id = u4VJ
// module chunks = 1